import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BButton',
  props: {
    size: { default: "md" },
    variant: { default: "primary" },
    icon: {},
    type: { default: "button" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    to: {},
    class: {},
    ariaLabel: {}
  },
  setup(__props: any) {

const props = __props;

// Provide aria-label when icon-only and no explicit label provided
const iconOnlyLabel = computed(() => {
    if (props.ariaLabel) return props.ariaLabel;
    return undefined;
});
const tag = computed(() => (props.to ? 'a' : 'button'));
const isDisabled = computed(() => props.disabled || props.loading);
const customClass = computed(() => props.class);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
    href: tag.value === 'a' ? __props.to : undefined,
    type: tag.value === 'button' ? __props.type : undefined,
    class: _normalizeClass(["btn", [`btn-${__props.size}`, `btn-${__props.variant}`, customClass.value]]),
    disabled: isDisabled.value,
    "aria-disabled": isDisabled.value
  }, {
    default: _withCtx(() => [
      (__props.icon && !__props.loading)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["bi pe-1", __props.icon]),
            "aria-hidden": "true"
          }, null, 2))
        : _createCommentVNode("", true),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["href", "type", "class", "disabled", "aria-disabled"]))
}
}

})